<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="handleSave"
        class="rkm-modal"
        extraLarge
        ref="RkmModal"
        title="Medicamento(s) de uso contínuo"
    >
        <Form
            :index="index"
            :data="data"
            @save="close()"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: null,
    }),
    methods: {
        async open(index, item) {

            this.$refs.RkmModal.show()

            this.index = index

            this.$nextTick().then(() => {

                this.$refs.Form.load(item)
            })
        },
        handleSave() {
            this.$refs.Form.save()
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>